<template>
  <div>
    <menubar :permission="permission" />
    <div class="container">
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">チーム一覧</p>
        </div>
        <div>
          <modal>
            <template v-slot:activator="{ openModal }">
              <button
                class="btn btn-purple show-modal"
                @click="
                  openModal();
                  clearForm();
                "
              >
                新規追加
              </button>
            </template>

            <template v-slot:modalTitle> チームの新規作成 </template>
            <template v-slot:modal-content="{ closeModal }">
              <div class="mb-3">
                <label class="form-label"
                  >チーム名<span class="mx-2 badge rounded-pill bg-danger"
                    >必須</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="entryTeamName"
                />
              </div>

              <div class="mb-3">
                <label class="form-label"
                  >管理人<span class="mx-2 badge rounded-pill bg-danger"
                    >必須</span
                  ></label
                >
                <select class="form-select" v-model="entryAdministrator">
                  <option
                    v-for="label in administrators"
                    :key="label"
                    v-bind:value="label.id"
                  >
                    {{ label.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="entryComment" class="form-label">特徴</label>
                <input
                  type="text"
                  class="form-control"
                  id="entryComment"
                  v-model="entryComment"
                />
              </div>

              <div class="modal-btn d-flex justify-content-evenly">
                <button class="btn btn-red" @click="closeModal()">
                  キャンセル
                </button>
                <button
                  class="btn btn-purple"
                  @click="
                    closeModal();
                    submitStore();
                  "
                >
                  登録
                </button>
              </div>
            </template>
          </modal>
        </div>
      </div>

      <div class="d-flex justify-content-start my-3">
        <div class="me-4">
          <span>社名・組織名</span>
          <span class="badge display-user mx-1">{{client_name}}</span>
        </div>
        <div class="me-4">
          <span>チーム数</span>
          <span class="badge display-user mx-1">{{ teamCount }}</span>
        </div>
      </div>

      <table class="table component_table">
        <thead>
          <tr>
            <th scope="col" class="text-center">No</th>
            <th scope="col" class="text-center">チーム名</th>
            <th scope="col" class="text-center">管理者</th>
            <th scope="col" class="text-center">権限</th>
            <th scope="col" class="text-center">メールアドレス</th>
            <th scope="col" class="text-center">メンバー数</th>
            <th scope="col" class="text-center">更新日</th>
            <th scope="col" class="text-center">編集</th>
            <th scope="col" class="text-center">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(team, index) in teams" :key="index">
            <td class="align-middle text-center">{{ index + 1 }}</td>
            <td class="align-middle">
              <!-- <a :href="'/teams/' + team.id"> TODO use InertiaLink -->
              <!-- {{ team.team }} -->
              <!-- </a> -->
              <Link :href="route('management.teams.show', team.id)">
                {{ team.team }}
              </Link>
            </td>
            <td class="align-middle">{{ team.administrator.name }}</td>
            <td class="align-middle">{{ team.authority }}</td>
            <td class="align-middle">{{ team.mail_address }}</td>
            <td class="align-middle text-center">{{ team.member_n }}</td>
            <td class="align-middle text-center">{{ showLocalDate(team.updated_at, "/") }}</td>
            <td class="align-middle">
              <modal>
                <template v-slot:activator="{ openModal }">
                  <div class="text-center">
                    <img
                      src="/img/17_edit.svg"
                      style="width: 1.5rem"
                      @click="
                        openModal();
                        setUpdateFormDefault(team);
                      "
                    />
                  </div>
                </template>

                <template v-slot:modalTitle> チーム編集 </template>
                <template v-slot:modal-content="{ closeModal }">
                  <div class="mb-3">
                    <label class="form-label"
                      >チーム名<span class="mx-2 badge rounded-pill bg-danger"
                        >必須</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="entryTeamName"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label"
                      >管理人<span class="mx-2 badge rounded-pill bg-danger"
                        >必須</span
                      ></label
                    >
                    <select class="form-select" v-model="entryAdministrator">
                      <option
                        v-for="label in administrators"
                        :key="label"
                        v-bind:value="label.id"
                      >
                        {{ label.name }}
                      </option>
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="entryComment" class="form-label">特徴</label>
                    <input
                      type="text"
                      class="form-control"
                      id="entryComment"
                      v-model="entryComment"
                    />
                  </div>
                  <div class="modal-btn d-flex justify-content-evenly">
                    <button class="btn btn-red" @click="closeModal()">
                      キャンセル
                    </button>
                    <button
                      class="btn btn-purple"
                      @click="
                        closeModal();
                        submitUpdate(team.id);
                      "
                    >
                      登録
                    </button>
                  </div>
                </template>
              </modal>
            </td>
            <td class="text-center align-middle">
              <input type="checkbox" v-model="team.delete" />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end text-end">
        <button
          class="btn btn-red"
          style="font-size: 0.9rem"
          @click="deleteUsers()"
        >
          削除
        </button>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import modal from "@/Pages/Components/modal.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from '@/Pages/Components/showLocalDate.js';

export default defineComponent({
  components: {
    Link,
    menubar,
    modal,
    footerComponent,
  },
  data() {
    return {
      entryTeamName: "",
      entryAdministrator: {},
      entryComment: "",
    };
  },
  props: {
    client_name: String,
    teams: Array,
    teamCount: Number,
    administrators: Array,
    csrf_token: String,
    permission: String,
  },
  methods: {
    showLocalDate: function (date, separator) {
      return showLocalDate.showLocalDate(date, separator);
    },
    clearForm() {
      this.entryTeamName = "";
      this.entryAdministrator = 0;
      this.entryComment = "";
    },
    setUpdateFormDefault(team) {
      this.entryTeamName = team.team;
      this.entryAdministrator = team.administrator.id;
      this.entryComment = team.comment;
    },
    checkForm() {
      this.errors = [];
      if (this.entryTeamName && this.entryAdministrator) {
        return true;
      }
      if (!this.entryName) {
        this.errors.push("氏名");
      }
      if (!this.entryAdministrator) {
        this.errors.push("管理人");
      }
      return false;
    },
    submitStore() {
      if (this.checkForm()) {
        // TODO console.logに登録済みを出す

        const team = {
          name: this.entryTeamName,
          admin: this.entryAdministrator,
          description: this.entryComment,
        };

        axios
          .post(route('management.teams.store'), team, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrf_token,
            },
          })
          .then((response) => {
            if (response.status === 204) {
              location.reload();
            }
          })
          .catch((error) => {
              alert(error.response.data);
          });
      } else {
        alert(this.errors + "を入力してください。");
      }
    },
    submitUpdate(id) {
      if (this.checkForm()) {
        // TODO console.logに登録済みを出す

        const team = {
          name: this.entryTeamName,
          admin: this.entryAdministrator,
          description: this.entryComment,
        };

        axios
          .put(route('management.teams.update', id), team, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrf_token,
            },
          })
          .then((response) => {
            if (response.status === 204) {
              location.reload();
            }
          })
          .catch((error) => {
              alert(error.response.data.message);
          });
      } else {
        alert(this.errors + "を入力してください。");
      }
    },
    deleteUsers() {
      if (
        confirm(
          "チームと連携する対訳ファイルも削除されますが、よろしいですか？"
        )
      ) {
        this.teams.forEach((team) => {
          if (team.delete) {
            axios
              .delete(route('management.teams.destroy', team.id), {
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                  "X-CSRF-TOKEN": this.csrf_token,
                },
              })
              .then((response) => {
                if (response.status === 204) {
                  location.reload();
                }
              })
              .catch((error) => {
              alert(error.response.data.message);
          });
          }
        });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.container {
  min-height: 80vh;
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  tbody {
    border-top: 0;
  }
}
.title-row,
.text-end {
  padding: 0 0 1rem 0;
}
.text-end {
  justify-content: flex-end;
}
.display-user {
  background: #aaaaaa;
}
</style>
